import { Component, inject, Input, OnInit } from '@angular/core';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';

import { DxDataGridComponent } from 'devextreme-angular';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import CustomStore from 'devextreme/data/custom_store';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import {
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { MovimentoArticolo } from 'src/app/models/movimento-articolo';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import { Dipendente } from 'src/app/models/dipendente';

@Component({
  selector: 'app-grid-consegne-compact',
  templateUrl: './grid-consegne-compact.component.html',
  styleUrls: ['./grid-consegne-compact.component.scss'],
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoColumnChooserComponent,
    DxoEditingComponent,
    DxoLookupComponent,
    DxoTextsComponent,
  ],
})
export class GridConsegneCompactComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private navService = inject(NavigatorService);
  private movArticoliService = inject(MovimentoArticoliService);
  private dipendentiService = inject(DipendentiService);
  private articoliService = inject(ArticoliService);
  @Input() idDipendente: number = 0;
  @Input() idArticolo: number = 0;

  dataSource: any;
  listDipendenti: Dipendente[] = [];
  listArticoli: any;
  columnResizingMode = 'widget';

  ngOnInit() {
    this.loadLookUp();
    this.loadConsegne();
  }

  loadLookUp() {
    // Dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listDipendenti = res;
        }
      }
    });

    //Articoli
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listArticoli = res.filter(x => x.attivo == true);
        }
      },
    });
  }

  loadConsegne() {
    this.dataSource = new CustomStore({
      key: ['idArticolo', 'idDipendente'],
      load: () => {
        return firstValueFrom(
          this.movArticoliService.list(this.idDipendente, this.idArticolo),
        )
          .then((response) => {
            // Ordina per data decrescente
            const sorted = response.sort(
              (a, b) => new Date(b.data).getTime() - new Date(a.data).getTime(),
            );
            // Prendi solo i primi 15
            const latest10 = sorted.slice(0, 10);

            return { data: latest10 };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }

  goToDetail(e:MovimentoArticolo) {
    if (this.idArticolo > 0) {
      this.navService.goToDipedenteDashboard(e.idDipendente);
    } else if (this.idDipendente > 0) {
      this.navService.goToArticoliDashboard(e.idArticolo);
    }
  }

  onExporting(e: any){
    const dip = this.listDipendenti.find(x => x.id == this.idDipendente);
    const nomeFile = 'Ultime_Consegne_' + (dip != undefined ? (dip?.nominativo + '.xlsx') : 'xlsx');
    GridExportExcel(e, 'Ultime Consegne', nomeFile);
  }
}
